import { useWhatsNew } from 'components/WhatsNew/useWhatsNew/useWhatsNew';
import styles from './Indicator.module.css';

type TProps = {
  introducerId: string;
};

export const Indicator = ({ introducerId }: TProps) => {
  const { numberUnread } = useWhatsNew({} as any, introducerId, true);
  return numberUnread > 0 ? <div className={styles.indicator} /> : null;
};
